import ProdutoService from '@/src/services/produto'

const produtoMixin = {
  data() {
    return {
      estoqueFields: [
        {
          key: 'nome',
          label: 'Produto',
          class: 'size-col-20',
        },
        {
          key: 'estoqueUnidade',
          label: 'Estoque disponível',
          class: 'size-col-20',
        },
      ],
      produtosFields: [
        {
          key: 'nome',
          label: 'Produto',
          class: 'size-col-20',
          field: 'nome',
        },
        {
          key: 'qtde_unitaria',
          label: 'Quantidade',
          class: 'size-col-20',
        },
        {
          key: 'valor',
          label: 'Valor',
          class: 'size-col-20',
        },
        { key: 'actions', label: '', class: 'size-col-10' },
      ],
    }
  },
  methods: {
    async registerProduto(produto) {
      return await ProdutoService.create(produto)
    },
    async uploadImage(image) {
      return await ProdutoService.uploadImage(image)
    },
    loadProdutos() {
      return ProdutoService.list()
        .then((response) => {
          return response
        })
        .catch((error) => error)
    },
    async editProduto(id, produto) {
      return await ProdutoService.update(id, produto)
    },
    async addEstoque(estoque){
      estoque.quantidade = parseInt(estoque.quantidade)
      return await ProdutoService.addEstoque(estoque)
    },
    async deleteProduto(id) {
      await ProdutoService.remove(id)
    },
  },
}

export default produtoMixin
